<template>
  <span>
    {{promoIntro}} <strong>{{pick.type}}</strong> on my <a href="/" @click.prevent="scrollToCapper">{{capper.title}}</a> service. Add it to your account here:
    <a class="button is-small is-success"
       :href="capper.paymentLinks[0] ? capper.paymentLinks[0].url : `tel:${propertyPhone}`">
      {{capper.paymentLinks[0] ? capper.paymentLinks[0].cta : 'Call Me'}}
    </a>
  </span>
</template>

<script>
export default {
  props: {
    capper: Object,
    pick: Object
  },
  data() {
    return {
      promoIntro: process.env.VUE_APP_WRITE_UP_PROMO_INTRO || 'To complete this game, I\'m betting the',
      propertyPhone: process.env.VUE_APP_PHONE
    }
  },
  methods: {
    scrollToCapper: function () {
      let elId = `available-capper-id-${this.capper.service}`;
      let el = document.getElementById(elId);

      if (el) {
        el.scrollIntoView({behavior: 'smooth'});
      } else if (this.capper.paymentLinks[0]?.url) {
        window.open(this.capper.paymentLinks[0].url, '_blank');
      }
    }
  }
}
</script>

<style scoped>

</style>